// extracted by mini-css-extract-plugin
module.exports = {"featuresContainer":"az_SPb"};